import React from 'react';
import PropTypes from 'prop-types';
import {Form} from 'semantic-ui-react';
import {omit} from "utils/DBUtils";
import ResourceFormProxy from "classes/ResourceFormProxy";

/**
 * Thin wrapper for semantic Form,
 * Implemented for use as section wrapper in resourceForm to remove formProxy from incoming props in order to suppress warning
 */
const BasicForm = (props) => {
    let newProps = omit(props, "formProxy");
    return (
        <Form {...newProps}>
            {props.children}
        </Form>
    );
};

BasicForm.propTypes = {
    formProxy: PropTypes.instanceOf(ResourceFormProxy)
};

export default BasicForm;



// WEBPACK FOOTER //
// ./public/components/forms/BasicForm.jsx